import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastComponent } from './toast.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        ToastComponent
    ],
    exports: [
        ToastComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule
    ]
})
export class ToastModule { }